// Voorkeursformaat: Opus in WebM is compact en wordt door Chrome, Edge en
// Firefox ondersteund. Safari kan dit (nog) niet opnemen en gooit dan een
// NotSupportedError, dus we vallen daar terug op MP4/AAC.
export const RECORDER_MIME_TYPE = 'audio/webm;codecs=opus';

// Volgorde = voorkeur. De laatste optie (lege string) betekent: laat de browser
// zelf kiezen; MediaRecorder krijgt dan helemaal geen mimeType mee.
const RECORDER_MIME_TYPE_CANDIDATES = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/mp4;codecs=mp4a.40.2',
    'audio/mp4',
    'audio/ogg;codecs=opus',
    'audio/ogg'
];

// Geeft het eerste formaat terug dat deze browser echt kan opnemen, of een lege
// string wanneer geen enkel kandidaat-formaat wordt herkend (browser beslist).
export const selectRecorderMimeType = (): string => {
    if (typeof MediaRecorder === 'undefined' || typeof MediaRecorder.isTypeSupported !== 'function') {
        return '';
    }

    for (const candidate of RECORDER_MIME_TYPE_CANDIDATES) {
        try {
            if (MediaRecorder.isTypeSupported(candidate)) {
                return candidate;
            }
        } catch {
            // isTypeSupported hoort niet te gooien, maar we willen hier nooit
            // op vastlopen: gewoon door naar de volgende kandidaat.
        }
    }

    return '';
};

// Bestandsextensie die bij het opnameformaat hoort; de server leidt hier het
// containerformaat uit af.
export const getRecorderFileExtension = (mimeType: string | null | undefined): string => {
    const normalized = (mimeType || '').toLowerCase();

    if (normalized.includes('mp4') || normalized.includes('m4a') || normalized.includes('aac')) {
        return 'm4a';
    }
    if (normalized.includes('ogg')) {
        return 'ogg';
    }
    if (normalized.includes('mpeg') || normalized.includes('mp3')) {
        return 'mp3';
    }
    if (normalized.includes('wav')) {
        return 'wav';
    }

    return 'webm';
};

export const calculateRecorderChunksSize = (chunks: Blob[]): number => {
    return chunks.reduce((totalSize, chunk) => totalSize + chunk.size, 0);
};

export const createRecorderBlob = (
    chunks: Blob[],
    mimeType: string = RECORDER_MIME_TYPE
): Blob => {
    return new Blob(chunks, { type: mimeType || RECORDER_MIME_TYPE });
};

export const isBlobCompleteForChunks = (blob: Blob | null | undefined, chunks: Blob[]): boolean => {
    if (!blob) {
        return false;
    }

    const expectedSize = calculateRecorderChunksSize(chunks);
    return expectedSize > 0 && blob.size === expectedSize;
};
